import React from "react";

const faq3 = () =>{
  return(
    <>
      <p>
        Verksamhetens resultat visas bland annat 
        som högsta möjliga löneuttag per månad – 
        efter skatter och avgifter. Du kan istället 
        välja annat nyckeltal du vill bevaka. 
      </p>
      <p>
        Du ser även löpande hur andra nyckeltal - 
        som exempelvis års-täckningsbidrag per 
        erbjudande och totalt för hela ditt utbud – 
        påverkas av de data du anger.
      </p>
      <p>
        Månadslön är ett kvalificerat närmevärde 
        byggt på de data du angett kring utbud, 
        kostnader och åtgärder för att gå i mål.
      </p>
      <p>
        Se Flik: <u>Så funkar <i>din</i>BiZ-analysen</u> <br/>     
        Se Flik: <u>Steg för lönsamhet</u> och samtliga 
        följande flikar t o m <u>LönsamhetsModeller</u>
      </p>
    
    </>
  );
}
export default faq3;